// Tooltip 配置選項
export const tooltipConfig = {
	// 預設欄位標籤
	defaultFieldLabels: {
		rank: "🏅 名次",
		originalValue: "📈 進步值",
		age: "👤 年齡",
		clubName: "🏠 店名",
		percent: "📊 佔比",
		count: "👥 區間人數",
		totalCount: "👥 總人數",
	},
};

// 核心工具函數
const createRow = (label, value) => `
    <div class="grades-chart-tooltip__row">
      <span class="grades-chart-tooltip__label">${label}</span>
      <span class="grades-chart-tooltip__value">${value}</span>
    </div>
  `;

const getLabel = (field, fieldLabels) => {
	if (typeof fieldLabels[field] === "function") return fieldLabels[field](field);
	return fieldLabels[field] || field;
};

const getFieldValue = (sourceData, field) => {
	if (!sourceData || !Object.prototype.hasOwnProperty.call(sourceData, field)) return "–";
	switch (field) {
		case "rank":
			return sourceData.rank;
		case "originalValue":
			return `${sourceData.originalValue}`;
		case "age":
			return sourceData.age != null ? `${sourceData.age}` : "–";
		case "clubName":
			return sourceData.clubName;
		case "percent":
			return sourceData.percent;
		case "count":
			return sourceData.count;
		case "totalCount":
			return sourceData.totalCount;
		default:
			return sourceData[field] ?? "–";
	}
};

// 散布圖用
export const scatterChartTooltipHTML = (params, sourceData, ageRangeColor, options = {}) => {
	const {
		showTitle = true,
		showDivider = true,
		customTitle,
		fields = ["rank", "originalValue", "age", "clubName"],
		fieldLabels = {
			rank: "🏅 名次",
			originalValue: "📈 進步值",
			age: "👤 年齡",
			clubName: "🏠 店名",
		},
		style = {},
	} = options;

	const rows = fields.map(field => createRow(getLabel(field, fieldLabels), getFieldValue(sourceData, field))).join("");

	return `
      <div class="grades-chart-tooltip__container ${style.container || ""}">
        ${
			showTitle
				? `
          <div class="grades-chart-tooltip__title">
            <span class="grades-chart-tooltip__color-dot" style="background-color: ${ageRangeColor};"></span>
            ${customTitle || params.seriesName}
          </div>
        `
				: ""
		}
  
        ${showDivider ? `<div class="grades-chart-tooltip__divider"></div>` : ""}
  
        <div class="grades-chart-tooltip__content">
          ${rows}
        </div>
      </div>
    `;
};

// 圓餅圖用
export const pieChartTooltipHTML = (params, sourceData, ageRangeColor) =>
	scatterChartTooltipHTML(params, sourceData, ageRangeColor, {
		showDivider: true,
		style: { container: "grades-chart-tooltip__container--simple" },
		fields: ["age", "count", "totalCount", "percent"],
		fieldLabels: {
			age: "🧓 年齡",
			count: "👥 區間人數",
			totalCount: "👥 總人數",
			percent: "📊 佔比",
		},
	});

// 導出工具對象（向後兼容）
export const TooltipUtils = {
	scatterChartTooltipHTML,
	pieChartTooltipHTML,
};
